import React from 'react';
import dcgLogo from '../../../assets/img/brand/dcg_logo_header.png';
import RequestPortalJoinCodePageContent from '../PageContent/ReqPortalJoinCodePageContent';
import { SectionDivider, PageTitle, HeaderAndBodyLayout } from '../../../utilities/dcgAutomationPageCommonImports';
import ComingSoon from '../../../components/ComingSoon/ComingSoon';


const RequestPortalJoinCode = () => {
    return (
        <HeaderAndBodyLayout headerLogo={dcgLogo} containerSize="sm">
            <PageTitle heading="Request a Portal Join Code" />
            <SectionDivider width="70%" />
            <ComingSoon />
            {/*<RequestPortalJoinCodePageContent />*/}
        </HeaderAndBodyLayout>
    );
};

export default RequestPortalJoinCode;